module.exports = __webpack_public_path__ + "static/media/Friends_Family_Discount.f05d5ce0.svg";